import {useFrontContext} from "v4/contexts/FrontContext";

export default function useA11YPopup(closePopup) {
    const {a11yForm, updateA11y} = useFrontContext();

    const onSubmit = (data) => {
        updateA11y(data);
        closePopup();
    }

    return {
        a11yForm,
        onSubmit,
    }
}
